import Nav from "../comps/nav"
import "../index.css"
import Footer from "../comps/footer";

export default function Motivations() {
    return (
        <main className="bg-[#f2f4f5] pb-24">
            <Nav/>
            <section className="relative px-4 pt-12 pb-12">
                <div className="w-[90%] md:w-2/3  mx-auto text-gray-800 text-left">
                    <h1 className="text-2xl font-semibold mb-8 text-center">Motivations behind the development of this app</h1>
                    <div className="space-y-6">
                        <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                            <h2 className="text-lg font-bold mb-2">Personal Experience</h2>
                            <p className="text-gray-500 mb-4">The Inspo</p>
                            <p>
                                AMII Health was inspired by personal experience(s).<br/><br/>

                                A while ago, my grandma randomly fainted on the street.
                                Unfortunately, she lives in Brooklyn while I live elsewhere, so it took me about 30
                                minutes to reach her.
                                That doesn't account for the unspecified time where she initially fainted, then arrived
                                at the ER, where someone contacted her emergency contact, who then conveyed that
                                information to me.<br/><br/>

                                In that critical time, only those nearby knew what was happening, and thankfully someone
                                called an ambulance.
                                But when she arrived at the ER, there was another challenge:<br/>
                                <ul className="list-disc pl-6 text-gray-700 my-2">
                                    <li>The only person who was a "translator" wasn't fluent in her dialect</li>
                                    <li>No one knew the medications she was taking at the time</li>
                                    <li>No one knew if/what she was allergic to anything</li>
                                </ul>
                                I was made aware of this when I got there, because they were asking me to ask her, but
                                she was groggy and confused.
                                Thankfully, I had another family member swing by her house to grab her medications and
                                rush them down to the ER.
                            </p>
                        </div>
                        <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                            <h2 className="text-lg font-bold mb-2">The Problem</h2>
                            <p className="text-gray-500 mb-4">Why accessible health info matters</p>
                            <p>
                                This experience made me realize how important it is to have health information easily
                                accessible, especially during emergencies.
                                With AMII Health, my goal is to help families and individuals bridge that gap.
                                The main feature I’ve focused on is a Medical ID wallet pass; easy to create and update,
                                and designed to display vital information quickly for nurses and first responders.
                                I hope this helps people communicate their health information, especially in situations
                                where they might forget or face language barriers.
                            </p>
                        </div>
                        <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                            <h2 className="text-lg font-bold mb-2">Looking Forward</h2>
                            <p className="text-gray-500 mb-4">Plans for multilingual support and safer healthcare</p>
                            <p>
                                While I know there are still challenges to solve, like making sure incident details are
                                communicated,
                                having critical health info available can make a real difference and cut down on delays
                                in treatment.
                                Looking ahead, I plan to make AMII Health fully multilingual, so people who don’t speak
                                English or have limited English skills can use the app with confidence.
                            </p>
                        </div>
                        <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                            <h2 className="text-lg font-bold mb-2">Accessibility & Sharing</h2>
                            <p className="text-gray-500 mb-4">1 for you, 1 for you, and 1 for you!</p>
                            <p>
                                For some context, I was born in a traditional Chinese household. My parents, my aunts,
                                my uncles, my grandparents, they might be some of the most stubborn people I've ever
                                met.
                                They don’t like change, they don’t like new technology, and they definitely don’t like
                                learning new things.
                                So I made sure to design AMII Health to be as simple and straightforward as possible,
                                but even then for those who are tech-adverse
                                I would like it so that even you can help them without them having to download the app
                                directly.<br/><br/>
                                <p className="text-gray-500 mb-4">If they don't have an email</p>
                                You can use your own account to create a Medical ID pass for someone else.
                                Just fill out their profile information, generate the pass and send it to yourself, and just send them the link.<br/><br/>
                                Ideally you can make an email for them, or they have an email, that way updating it is much easier
                            </p>
                        </div>
                        <div className="text-center">
                            <h2 className="text-lg font-bold mb-2">The End</h2>
                            <p className="text-gray-500 mb-4">If you read through to the end, thank you :)</p>
                            <p>
                                I hope you will try out AMII Health.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </main>
    );
}
